"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const MatchSearchResultItem_1 = __importDefault(require("@Components/MatchComponents/v2/MatchSearchResultItem"));
require("./index.scss");
const SubmissionFilterSection_1 = __importDefault(require("@Components/MatchComponents/v2/SubmissionFilterSection"));
const mobx_react_1 = require("mobx-react");
const CardResults_1 = __importDefault(require("@Components/CardResults"));
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const Sidebar_1 = require("@Components/Sidebars/Sidebar");
const DownloadSidebar_1 = require("@Components/Sidebars/DownloadSidebar");
const sidebar_download_type_1 = require("@App/enum/sidebar-download-type");
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Button_1 = require("@Components/Buttons/Button");
const MatchHistorySearchContentHeader_1 = __importDefault(require("@Components/MatchComponents/MatchHistory/MatchHistorySearchContentHeader"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const MatchHistorySearch = () => {
    const { matchHistoryStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [sidebarIsOpen, setSidebarIsOpen] = (0, react_1.useState)(false);
    const closeSidebar = () => {
        setSidebarIsOpen(false);
    };
    const getMatchHistory = () => {
        setLoading(true);
        matchHistoryStore.loadMatchSuggestionHistory().finally(() => {
            setLoading(false);
        });
    };
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('match_history_search');
        if (matchHistoryStore.isDefaultPagination) {
            getMatchHistory();
        }
    }, []);
    const onChangeLimit = (newLimit) => {
        matchHistoryStore.setMatchSuggestionHistoryResultsLimit(newLimit);
        getMatchHistory();
    };
    const onChangePagination = (body) => {
        matchHistoryStore.setMatchSuggestionHistoryPaginationBody(body);
        getMatchHistory();
    };
    return (react_1.default.createElement("div", { className: "match-history-wrapper" },
        react_1.default.createElement(MatchHistorySearchContentHeader_1.default, null),
        react_1.default.createElement(SubmissionFilterSection_1.default, { setLoading: setLoading }),
        !loading && (react_1.default.createElement("div", { className: 'export-button-row' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: "primary", className: "export-search-button", onClick: () => setSidebarIsOpen(true) }, "Export"))),
        loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(CardResults_1.default, { data: matchHistoryStore.matchSuggestionHistory ? matchHistoryStore.matchSuggestionHistory.content : [], count: matchHistoryStore.matchSuggestionHistory
                ? matchHistoryStore.matchSuggestionHistory.totalElements
                : 0, paginationInfo: matchHistoryStore.matchSuggestionHistoryPagination, limit: matchHistoryStore.matchSuggestionHistoryResultsLimit, onChangeLimit: onChangeLimit, onChangePage: onChangePagination, compactCardType: MatchSearchResultItem_1.default, extendedCardType: MatchSearchResultItem_1.default, compact: true })),
        react_1.default.createElement(ModalPortal_1.default, { isOpen: sidebarIsOpen, onClose: closeSidebar },
            react_1.default.createElement(Sidebar_1.Sidebar, { onClose: closeSidebar },
                react_1.default.createElement(DownloadSidebar_1.DownloadSidebar, { closeSidebar: closeSidebar, sidebarDownloadType: sidebar_download_type_1.SidebarDownloadType.MatchHistoryExport })))));
};
exports.default = (0, mobx_react_1.observer)(MatchHistorySearch);
